import { useQuery } from '../useQuery';
import {
  getQualifiedResources,
  getResources,
  getResourcesPaginated,
} from '@dispatch/shared/services';
import { useFilter } from '../filter/FilterContext';
import { usePaginatedQuery } from '../api/usePaginatedQuery';
import {
  BaseResourcesListFilter,
  ResourcesListFilter,
} from '@dispatch/shared/types';
import { isEmpty, isNil } from 'lodash';
import { GridSortItem } from '@mui/x-data-grid-pro';

export const useGetResources = (
  enabled?: boolean,
  filters?: BaseResourcesListFilter
) => {
  const { data: resources, status: resourcesStatus } = useQuery(
    ['resources', filters],
    () => getResources(filters),
    {
      enabled: !isNil(enabled) ? enabled : true,
    }
  );

  return {
    data: resources,
    status: resourcesStatus,
  };
};

export const useGetQualifiedResources = (
  taskId?: string,
  enabled?: boolean
) => {
  const { filters, quickFilters } = useFilter();

  return useQuery(
    ['resources', filters?.search, quickFilters?.isActive, taskId],
    () => {
      return getQualifiedResources(taskId);
    },
    {
      enabled: !isNil(enabled) ? enabled : true,
      cacheTime: 0,
      refetchOnMount: 'always',
    }
  );
};

export const useGetResourcesPaginated = ({
  filters,
  sorting,
  enabled = true,
}: {
  filters: ResourcesListFilter;
  sorting?: GridSortItem | null;
  enabled?: boolean;
}) => {
  const isEnabled = enabled && !isEmpty(filters);

  return usePaginatedQuery(
    ['resources', filters, sorting],
    (token) => getResourcesPaginated(filters, token, sorting),
    {
      enabled: isEnabled,
    }
  );
};
